// /client/src/utils/cookieBanner.js

import analyticsManager from './analytics';

// SilkTide Cookie Banner Configuration
const cookieBannerConfig = {
  // Banner positioning
  position: {
    banner: 'bottomRight' // bottomLeft, bottomCenter, center
  },

  // Cookie icon settings
  cookieIcon: {
    position: 'bottomLeft', // bottomRight
    colorScheme: 'light' // dark
  },

  // Background backdrop
  background: {
    showBackground: true
  },

  // Text customization
  text: {
    banner: {
      description: 'We use cookies to enhance your browsing experience, provide personalized content, and analyze our traffic. By clicking "Accept All", you consent to our use of cookies.',
      acceptAllButtonText: 'Accept All',
      rejectNonEssentialButtonText: 'Decline',
      preferencesButtonText: 'Cookie Preferences'
    },
    preferences: {
      title: 'Cookie Preferences',
      description: '<p>We respect your privacy and give you control over your data. You can choose which types of cookies to allow. Please note that blocking some types of cookies may impact your experience on our website.</p>',
      creditLinkText: 'Powered by Silktide'
    }
  },

  // Cookie types configuration
  cookieTypes: [
    {
      id: 'essential',
      name: 'Essential Cookies',
      description: 'These cookies are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you which amount to a request for services.',
      required: true,
      defaultValue: true,
      onAccept: () => {
        
        // Essential cookies are always accepted
      },
      onReject: () => {
       
      }
    },
    {
      id: 'analytics',
      name: 'Analytics Cookies',
      description: 'These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve our website and services.',
      required: false,
      defaultValue: false,
      onAccept: async () => {
       
        await analyticsManager.enableAnalytics();
        
        // Track the current page view (now waits for GA to be ready)
        const currentPath = window.location.pathname;
        const currentTitle = document.title;
        analyticsManager.trackPageView(currentPath, currentTitle);
      },
      onReject: () => {
        
        analyticsManager.disableAnalytics();
      }
    },
    {
      id: 'marketing',
      name: 'Marketing Cookies',
      description: 'These cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user.',
      required: false,
      defaultValue: false,
      onAccept: () => {
        
        // Add marketing tracking here if needed
      },
      onReject: () => {
       
        // Remove marketing tracking here if needed
      }
    }
  ],

  // Global callbacks
  onAcceptAll: () => {
    
    // This fires when user clicks "Accept All"
  },

  onRejectAll: () => {
    
    // This fires when user clicks "Reject All"
  },

  onBannerOpen: () => {
    
  },

  onBannerClose: () => {
    
  },

  onPreferencesOpen: () => {
    
  },

  onPreferencesClose: () => {

  }
};

// Function to initialize the cookie banner
export const initializeCookieBanner = () => {
  // Check if SilkTide is available
  if (typeof window !== 'undefined' && window.silktideCookieBannerManager) {
    // Update the cookie banner configuration
    window.silktideCookieBannerManager.updateCookieBannerConfig(cookieBannerConfig);
    
  } else {
    console.error('SilkTide Cookie Banner Manager not found');
  }
};

// Function to check if analytics cookies are accepted
export const areAnalyticsCookiesAccepted = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const analyticsChoice = localStorage.getItem('silktideCookieChoice_analytics');
    return analyticsChoice === 'true';
  }
  return false;
};

// Function to manually trigger analytics for existing consent
export const initializeAnalyticsIfConsented = async () => {
  if (areAnalyticsCookiesAccepted()) {
    await analyticsManager.enableAnalytics();
    
  }
};

export default cookieBannerConfig;